"use client";

import viugoSearchIcon from "@/assets/images/viugo/kbv-v16-search-icon.svg";
import viugoChevronDownIcon from "@/assets/images/viugo/kbv-v16-chevron-down-icon.svg";

export default function LeagueFilterV20Controls({
  keyword,
  onKeywordChange,
  onOpen,
  onToggleOpen,
  open,
  triggerLabel,
  fieldBaseClassName,
}) {
  return (
    <div className="flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:items-stretch sm:gap-3">
      <div className="relative flex w-full min-w-0 sm:w-1/2">
        <input
          type="text"
          placeholder="Tìm đội bóng theo tên"
          value={keyword}
          onChange={(e) => onKeywordChange(e.target.value)}
          onFocus={onOpen}
          onClick={onOpen}
          className={`${fieldBaseClassName} pr-[30px] placeholder:text-[var(--theme-text)]/55`}
        />
        <div
          className="pointer-events-none absolute inset-y-0 right-0 flex w-[30px] items-center justify-center text-[var(--theme-primary)]"
          aria-hidden
        >
          <img
            src={viugoSearchIcon}
            alt=""
            width={17}
            height={17}
            className="shrink-0"
            aria-hidden
          />
        </div>
      </div>

      <button
        type="button"
        onClick={onToggleOpen}
        className={`${fieldBaseClassName} flex cursor-pointer select-none items-center justify-between gap-2.5 text-left sm:w-1/2`}
      >
        <span className="min-w-0 truncate">{triggerLabel}</span>
        <span className="flex h-6 w-6 shrink-0 items-center justify-center">
          <img
            src={viugoChevronDownIcon}
            alt=""
            width={20}
            height={20}
            className={`shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
            aria-hidden
          />
        </span>
      </button>
    </div>
  );
}
